import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AuthService } from './services/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RouterOutlet } from '@angular/router';
import { FeedbackComponent } from './components/feedback/feedback.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    SidebarComponent,
    RouterOutlet,
    FeedbackComponent
  ],
  template: `
    <ng-container *ngIf="(isAuthenticated$ | async) !== null">
      <!-- Authenticated View -->
      <div class="app-container" *ngIf="isAuthenticated$ | async">
        <!-- Desktop Sidebar -->
        <app-sidebar></app-sidebar>

        <!-- Main Content -->
        <main class="main-content">
          <router-outlet></router-outlet>
        </main>
        
        <!-- Feedback component only for authenticated users -->
        <app-feedback></app-feedback>
      </div>

      <!-- Non-Authenticated View -->
      <div class="auth-container" *ngIf="!(isAuthenticated$ | async)">
        <router-outlet></router-outlet>
      </div>
    </ng-container>
  `,
  styles: [`
    .app-container {
      display: flex;
      min-height: 100vh;
      background-color: #f8f9fa;
    }

    .main-content {
      flex: 1;
      padding: 2rem;
      overflow-x: hidden;
    }

    .auth-container {
      height: 100vh;
      width: 100vw;
      background-color: #f8f9fa;
    }

    /* Desktop Styles */
    @media (min-width: 769px) {
      .main-content {
        margin-left: 250px;
      }
    }

    /* Mobile Styles */
    @media (max-width: 768px) {
      .main-content {
        margin-left: 0;
        padding: 1rem;
        padding-bottom: calc(70px + env(safe-area-inset-bottom, 20px));
      }
    }

    /* iPhone Safe Area Support */
    @supports (padding: max(0px)) {
      .main-content {
        padding-left: max(1rem, env(safe-area-inset-left));
        padding-right: max(1rem, env(safe-area-inset-right));
      }
    }
  `]
})
export class AppComponent implements OnInit {
  isAuthenticated$: Observable<boolean>;

  constructor(private authService: AuthService) {
    this.isAuthenticated$ = this.authService.user$.pipe(
      map(user => user !== null)
    );
  }

  ngOnInit(): void {}
}